<template>
  <div class="u-flex u-align-center">
    <blob-panel>
      <h1 class="text-center">
        Reset Password
      </h1>

      <form role="form" @submit.prevent="submit">
        <div class="form-group" :class="formClass('email')">
          <label for="email">
            Email
          </label>
          <input
            id="email"
            v-model="user.email"
            name="email"
            type="email"
            class="form-control"
            required
            autocomplete="email"
            @input="updateScore"
          >

          <span v-for="error in errors['email']" v-if="errors['email']" class="help-block"><strong v-text="error" /><br></span>
        </div>

        <div class="form-group" :class="formClass('password')">
          <label>Password</label>
          <vue-password
            v-model="user.password"
            name="password"
            autocomplete="off"
            :user-inputs="[user.name, user.email]"
            required
            @input="updateScore"
          />
          <div v-if="errors['password']">
            <span
              v-for="error in errors['password']"
              class="help-block"
            >
              <strong v-text="error" /><br>
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="password-confirm">
            Confirm password
          </label>
          <input
            id="password-confirm"
            v-model="user.password_confirmation"
            name="password-confirm"
            type="password"
            class="form-control"
            required
            autocomplete="off"
            @input="updateScore"
          >
        </div>

        <div class="u-mt-x-large">
          <button type="submit" class="btn btn--primary">
            Reset Password
          </button>
        </div>
      </form>
    </blob-panel>

    <a href="/login" class="emphasis-link u-mb-x-large">
      Already have an account? Sign in here
    </a>
  </div>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'
import { MessageLevel } from '@qlik-trial/automations-ui'

export default {
  components: { VuePassword: () => import(/* webpackChunkName: "vue-password" */'./VuePassword') },
  props: ['token'],

  data() {
    return {
      user: {
        email: '',
        password: '',
        password_confirmation: '',
      },
      errors: [],
      cancel: null,
    }
  },

  methods: {
    submit() {
      axios.post(
        '/password/reset',
        { ...this.user, token: this.token },
        { errorHandling: { 429: false } },
      )
        .then(response => {
          window.location.href = response.data.redirect
        })
        .catch(error => {
          this.errors = error.response.data

          if (error.response.status === 429) {
            this.flash({
              message: 'Too many requests have been made. Please try again later.',
              level: MessageLevel.WARNING,
            })
          }
        })
    },

    formClass(name) {
      if (this.errors[name]) {
        return 'has-error'
      }
    },

    updateScore() {
      if (this.cancel) {
        this.cancel()
      }
    },
  },
}
</script>
